import React from "react";
import img from "../images/pricing.jpg";
import Back from "../common/Back";
import "./contact.css";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";

const Contact = () => {
  const { t } = useTranslation();

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    formData.append("access_key", "c3c7a5d3-255a-47f5-91c4-0e2aefbf2fb6");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: json,
    }).then((res) => res.json());

    if (res.success) {
      Swal.fire({
        title: t("contactPage.successTitle"),
        text: t("contactPage.successMessage"),
        icon: "success",
      });
    }
  };

  return (
    <>
      <section className="contact mb">
        <Back
          name={t("contactPage.backName")}
          title={t("contactPage.backTitle")}
          cover={img}
        />

        <br />

        <div className="container">
          <div
            className="row shadow"
            style={{ paddingTop: "10px", paddingBottom: "10px" }}
          >
            <iframe
              title="google map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d230886.6290754265!2d51.347184701632926!3d25.28391755695891!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x63a445f1c41401c9%3A0x383d8f8a5728b0f8!2sEmaad%20Abdullah%20Al%20Fakhri%20Trading%2C%20Contracting%20%26%20IT%20Services!5e0!3m2!1sen!2sin!4v1749125299988!5m2!1sen!2sin"
              width="100%"
              height="500"
              style={{ border: 0 }}
              loading="lazy"
            ></iframe>
          </div>
        </div>

        <br />

        <div className="container">
          <div className="row shadow">
            <div className="col-lg-1"></div>

            <div className="col-lg-5">
              <br />
              <br />
              <h3 className="center5">{t("contactPage.sectionTitle1")}</h3>
              <h3 className="center4">{t("contactPage.sectionTitle2")}</h3>
              <br />

              <div className="servicelink">
                <span className="fa fa-map-marker bulletlist111"></span>
                <span>{t("contactPage.address")}</span>
              </div>

              <div className="servicelink">
                <a
                  href="tel:+97430666937"
                  style={{ textDecoration: "none", color: "#000" }}
                >
                  <span className="fa fa-phone bulletlist111"></span>
                  <span>{t("contactPage.phone")}</span>
                </a>
              </div>

              <div className="servicelink">
                <a
                  href="mailto:info@eaf-tc.com"
                  style={{ textDecoration: "none", color: "#000" }}
                >
                  <span className="fa fa-envelope bulletlist111"></span>
                  <span>{t("contactPage.email1")}</span>
                </a>
              </div>

              <div className="servicelink">
                <a
                  href="mailto:infoemaad@gmail.com"
                  style={{ textDecoration: "none", color: "#000" }}
                >
                  <span className="fa fa-envelope bulletlist111"></span>
                  <span>{t("contactPage.email2")}</span>
                </a>
              </div>

              <div className="servicelink">
                <a
                  href="https://www.eaf-tc.com"
                  style={{ textDecoration: "none", color: "#000" }}
                >
                  <span className="fa fa-globe bulletlist111"></span>
                  <span>{t("contactPage.website")}</span>
                </a>
              </div>
            </div>

            <div className="col-lg-5">
              <form className="center5" onSubmit={onSubmit}>
                <h4>{t("contactPage.formTitle")}</h4>
                <br />

                <div>
                  <input
                    className="form1"
                    type="text"
                    placeholder={t("contactPage.name")}
                    name="name"
                    required
                  />
                  <input
                    className="form1"
                    type="text"
                    placeholder={t("contactPage.email")}
                    name="email"
                    required
                  />
                </div>

                <input
                  className="form1"
                  type="tel"
                  name="phone"
                  placeholder={t("contactPage.mobile")}
                  required
                />

                <textarea
                  className="form1"
                  name="message"
                  cols="30"
                  rows="7"
                  placeholder={t("contactPage.subject")}
                  required
                ></textarea>

                <button type="submit" className="callbutton">
                  {t("contactPage.submit")}
                </button>
              </form>
            </div>

            <div className="col-lg-1"></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
